<template>    
  <div id="formulario-edit-info">   
    <vs-popup fullscreen title="Contas" :active.sync="popUpPesquisaConta.popupActive">
       
       <div class="vx-row mb-2">               
           <div class="vx-col w-1/2">
               <label class="vs-input--label">Favorecido</label> 
               <vs-input class="w-full" v-model="popUpPesquisaConta.filtro.nomeFavorecido" @keyup.enter="fetchListaContas()" style="padding-right: 5px;" />
           </div>
           <div class="vx-col w-1/2">
               <label class="vs-input--label">Número Conta</label> 
               <vs-input class="w-full" v-model="popUpPesquisaConta.filtro.numeroConta" @keyup.enter="fetchListaContas()" style="padding-right: 5px;" />
           </div>
       </div>   
       <div class="vx-row mb-2">               
           <div class="vx-col w-1/2">
                <label class="vs-input--label mr-2">Período</label>              
                <div class="flex items-center">
                <flat-pickr v-model="popUpPesquisaConta.filtro.dataInicio" class="mb-4 md:mb-0 w-full opacity-75" :config="configDatePicker" />
                <label class="vs-input--label mr-2">à</label>
                <flat-pickr v-model="popUpPesquisaConta.filtro.dataFim" class="mb-4 md:mb-0 w-full opacity-75" :config="configDatePicker"/>
                </div>           
           </div>  
           <div class="vx-col w-1/2">
             <label class="vs-input--label">Status</label>              
             <v-select                                               
                :options="CONSTANTE_STATUS_CONTA" 
                v-model="popUpPesquisaConta.filtro.statusConta"      
                :reduce="d => d.data"                              
                class="v-select w-full ml-1"
                style="padding-right: 10px;" >
             </v-select>
           </div>    
        </div>
       <div class="flex w-full">
           <vs-button class="mr-2 mt-2" size="small" @click="fetchListaContas" color="dark">PESQUISAR</vs-button>                                          
       </div>
       <vx-card class="mb-1">
            <ag-grid-vue
                ref="agGridTable"           
                :gridOptions="configuracaoGrid.gridOptions"
                class="ag-theme-material ag-grid-table ag-grid-altura"
                :columnDefs="configuracaoGrid.columnDefs"
                :defaultColDef="configuracaoGrid.defaultColDef"
                :rowData="dadosDaGrid"
                :rowHeight="38"
                :headerHeight="25"        
                rowSelection="single"
                colResizeDefault="shift"
                @row-selected="onRowSelectedRegistro"    
                :animateRows="true"
                :floatingFilter="false"
                :pagination="false"
                :paginationAutoPageSize="false"
                :suppressPaginationPanel="true"
                >
            </ag-grid-vue>      
        </vx-card>
    </vs-popup>
    <ExibirErrosConcept :errorsValidacao="errorsValidacao" ref="errosComponent"></ExibirErrosConcept>
      
    <vx-card>
        <div class="vx-row mb-4">
            <div class="vx-col md:w-1/2 w-full">                    
                <vs-button class="ml-auto mt-2" size="small" @click="gravar" color="success">Gravar</vs-button>                
                <vs-button class="ml-4 mt-2" size="small" @click="excluir" v-show="isDeletable" color="danger">Excluir</vs-button>            
                <vs-button class="ml-4 mt-2" size="small" type="border" color="dark" @click="voltar">Voltar</vs-button>             
            </div>
        </div>
        <div class="vx-row">
            <div class="vx-col w-1/4 text-center">
                <label class="vs-input--label">Conta</label>    
                <p v-if="data_local.conta.hasOwnProperty('id')"> {{ data_local.conta.numeroConta }} </p>                    
                <vs-button class="ml-auto mt-2" size="small" @click="abrirPopUpPesquisaContas" color="success">+</vs-button>
            </div>                              
            <div class="vx-col w-1/4 text-center">
                <label class="vs-input--label">Favorecido</label>                    
                <p v-if="data_local.conta.hasOwnProperty('favorecido')"> {{ data_local.conta.favorecido.nome }} </p>          
            </div>
            <div class="vx-col w-1/4  text-center">
                <label class="vs-input--label">Data de Vencimento</label>                    
                <p v-if="data_local.conta.hasOwnProperty('vencimento')"> {{ formatarData(data_local.conta.vencimento) }} </p>     
            </div>
            <div class="vx-col w-1/4  text-center">
                <label class="vs-input--label">Valor</label>                    
                <p v-if="data_local.conta.hasOwnProperty('valor')"> {{ formatarReal(data_local.conta.valor) }} </p>     
            </div>                               
        </div>                              
        <div class="vx-row">
            <div class="vx-col w-1/3">       
                <label class="vs-input--label">PERIODICIDADE</label>     
                <v-select                                               
                    :options="CONSTANTE_COMBO_PERIODICIDADE" 
                    v-model="data_local.periodicidade"        
                    :reduce="d => d.data"   
                    :clearable="false"              
                    class="v-select w-full">
                </v-select>                               
            </div> 
            <div class="vx-col w-1/3">
                <label class="vs-input--label">Início da Periodicidade</label>
                <flat-pickr v-model="data_local.dataInicioRecorrencia" class="mb-4 md:mb-0 w-full opacity-75" :config="configDatePicker"  />
            </div>     

            <div class="vx-col w-1/3">
                <label class="vs-input--label">Fim da Periodicidade</label>
                <flat-pickr v-model="data_local.dataFimRecorrencia" class="mb-4 md:mb-0 w-full opacity-75" :config="configDatePicker"  />
            </div> 
            
        </div> 
    </vx-card>  
    
  </div>
</template>

<script>

import generico from '@/generico.js'
import axios from "@/axios.js"
import VueAutonumeric from 'vue-autonumeric/src/components/VueAutonumeric.vue';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import {Portuguese as PortugueseLocale} from 'flatpickr/dist/l10n/pt.js';
//import {english as EnglishLocale} from 'flatpickr/dist/l10n/default.js'
//import {Spanish as SpanishLocale} from 'flatpickr/dist/l10n/es.js'
import { AgGridVue } from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'

const URL_SERVLET = "/ContaRecorrente";
const NAME_ROUTE_SEARCH = "financeiro-conta-recorrente-pesquisar";

const CONSTANTE_COMBO_PERIODICIDADE = [
    {label:"Mensal", data:"MENSAL"},
	{label:"Trimestral", data:"TRIMESTRAL"},
	{label:"Semestral", data:"SEMESTRAL"},
	{label:"Anual", data:"ANUAL"} 
];

import { CONSTANTE_STATUS_CONTA } from '@/constantesComboBox.js'

export default { 
  components: {  
    VueAutonumeric,
    flatPickr,
    AgGridVue
  },      
  props: {
    registroOriginal: {
      type: Object,
      required: false,
      default: function () {
        return { conta: {id: null}, dataInicioRecorrencia: null, dataFimRecorrencia: null,  periodicidade: null }
       }
    },
  },
  data() {
    return {        
        errorsValidacao: [],  
        data_local: JSON.parse(JSON.stringify(this.registroOriginal)), 
        listaFavorecido: [],
        configDatePicker: {          
          altInput: true,
          altFormat: "d-m-Y",
          dateFormat: "Y-m-d", 
          altInputClass: "vs-inputx vs-input--input normal hasValue text-center",
          locale: PortugueseLocale
        },  
        popupDuplicar: {
            popupActive: false,
            quantidadeDuplicacao: 0
        }, 
        popUpPesquisaConta: {
            popupActive:false,
            filtro : { nomeFavorecido: null, numeroConta: null, dataInicio: null, dataFim: null, statusConta: null }
        },
        configuracaoGrid: { 
          gridApi: null, 
          gridOptions: {
            rowClassRules: {          
              'rag-green-outer': function(params) { return params.data.status === 'PROVISORIA'; },
              'rag-amber-outer': function(params) { return params.data.isVencida; },
              'rag-cancelada':   function(params) { return params.data.status === 'CANCELADA'; },
            },
          }, 
          defaultColDef: { sortable: true, resizable: true, suppressMenu: true  },
          columnDefs: [        
            { headerName: 'N.', field: 'numeroConta', width: 35, cellRenderer: function(params) { return "<strong>" + params.data.numeroConta+ "</strong>"},
                cellStyle: params => {
                    if (params.data.status === 'PAGA') {                        
                        return {color: 'green', 'text-decoration': 'line-through'};
                    }
                    return null;
                } },                       
            { headerName: 'UNIDADE', field: 'unidadeOperacional.nome', width: 45},
            { headerName: 'VENCIMENTO', field: 'vencimentoFormatado', width: 45},                
            { headerName: 'VALOR', field: 'valor', width: 45, cellRenderer: function(params) { return generico.formatarMoedaReal(params.data.valor) },
                cellStyle: params => {
                    if (params.data.status === 'PAGA') {                        
                        return {color: 'green'};
                    }
                    return null;
                }
            },                            
            { headerName: 'FORNECEDOR', field: 'favorecido.nome'},                
            { headerName: 'CONTA', field: 'contaPlanoConta.nome', width: 150, cellRenderer : function(params) {
                  return params.data.contaPlanoConta.nome + (params.data.complemento ? "<br/> <small>" + params.data.complemento + "</small>": ""); 
                } 
            },
            { headerName: 'STATUS', field: 'status', width: 75},                
          ]
      },
      dadosDaGrid: [],
      totalRegistros: 0,
    }
  },  
  created(){
    this.CONSTANTE_COMBO_PERIODICIDADE = CONSTANTE_COMBO_PERIODICIDADE;
    this.CONSTANTE_STATUS_CONTA = CONSTANTE_STATUS_CONTA;
  }, 
  mounted() {
    this.configuracaoGrid.gridApi = this.configuracaoGrid.gridOptions.api;
  },
  computed: {        
    isDeletable() {
       return this.data_local != null && this.data_local.hasOwnProperty("id");
    },    
  },
  methods: {  
    abrirPopUpPesquisaContas(){
        var date = new Date();
        let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
        let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        this.popUpPesquisaConta.filtro.dataInicio = firstDay.toISOString().split('T')[0];
        this.popUpPesquisaConta.filtro.dataFim = lastDay.toISOString().split('T')[0];
        this.popUpPesquisaConta.popupActive = true;
        
        this.configuracaoGrid.gridApi.sizeColumnsToFit();      
    },
    formatarReal(valor) {
        return generico.formatarMoedaReal(valor);
    },
    formatarData(valor) {
        return generico.formatarDataYYYYMMDD(valor);
    },    
    fetchListaContas() {     
      this.$vs.loading() 
      const params = new URLSearchParams();
      params.append('pagina', -1);
      
      if (this.popUpPesquisaConta.filtro.nomeFavorecido) {
        params.append("favorecido.nome", this.popUpPesquisaConta.filtro.nomeFavorecido);
      }
                  
      if (this.popUpPesquisaConta.filtro.numeroConta) {
        params.append("numeroConta", this.popUpPesquisaConta.filtro.numeroConta);	
      }

      if (this.popUpPesquisaConta.filtro.statusConta) {
        params.append("status", this.popUpPesquisaConta.filtro.statusConta);
      }

      if(this.popUpPesquisaConta.filtro.dataInicio != null){
        params.append("vencimentoInicio", this.popUpPesquisaConta.filtro.dataInicio);
      }
      
      if(this.popUpPesquisaConta.filtro.dataFim != null){
        params.append("vencimentoFim", this.popUpPesquisaConta.filtro.dataFim);
      }

      axios.post("/Conta/ListarConta", params, {              
              credentials: 'include',
              responseEncoding: 'iso88591',
              withCredentials: true } )
      .then((response) => {
          this.$vs.loading.close();
          if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
              this.$router.push({ path: '/' });
          } else {
              this.totalRegistros = response.data.Resultado.quantidade;
              this.dadosDaGrid = response.data.Resultado.lista;                            

              this.totalPago = 0; 
              this.totalEmAberto = 0;
              this.totalProvisorio = 0;
              this.totalVencido = 0;

              if (this.totalRegistros > 0) {
                 let registro = null;
                 for(let j=0; j < this.dadosDaGrid.length; j++) {  
                    registro = this.dadosDaGrid[j];
                    if (registro.status == 'ABERTA') {
                        this.totalEmAberto = this.totalEmAberto + parseFloat(registro.valor);
                        if (registro.isVencida) {
                          this.totalVencido = this.totalVencido + parseFloat(registro.valor);
                        }
                    } else if (registro.status == 'PAGA') {
                        this.totalPago = this.totalPago + parseFloat(registro.valor);
                    } else if (registro.status == 'PROVISORIA') {
                        this.totalProvisorio = this.totalProvisorio + parseFloat(registro.valor);
                    }

                 }
              } 
          }
      })
      .catch((error) => { 
          this.$vs.loading.close();
          /* eslint-disable no-console */ console.log("EFETUAR LOGOFF! - fetchLista - " + error); 
      })    
                        
    },
    findById() {       
        const params = new URLSearchParams();       
        params.append('id', this.data_local.id);           
                
        axios.post(URL_SERVLET + "/RecuperarContaRecorrente", params, {              
            headers: {'Accept': 'application/json' }, credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
        .then((response) => {
            this.$vs.loading.close();
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                this.$router.push({ path: '/login' });
            } else {                
                 this.data_local = response.data.ContaRecorrente;                  
            }
        })
        .catch((error) => { 
            /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - gravar - " + error); 
        })  
    }, 
    excluir() {
        this.$vs.dialog({
          type: 'confirm', color: 'warning', title: 'Atenção', text: 'Deseja excluir ?', acceptText: 'Sim', cancelText: 'Não', accept: this.excluirRequest
        });
    },
    excluirRequest() {
        this.$vs.loading();  
        const params = new URLSearchParams();                
        params.append('id', this.data_local.id);   
                
        axios.post(URL_SERVLET + "/RemoverContaRecorrente", params, {              
                credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
        .then((response) => {
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                this.$router.push({ path: '/' });
            } else {
                this.$vs.loading.close();
                if (response.data.toUpperCase().indexOf("ERRO") != -1) {
                    this.$vs.dialog({ color: 'danger', title: 'Erro', text: response.data, acceptText: 'OK'})
                } else {
                    this.$router.push({ name: NAME_ROUTE_SEARCH })
                }                   
            }
        })
        .catch((error) => { 
            this.$vs.loading.close();
            /* eslint-disable no-console */ console.log("EFETUAR LOGOFF! - gravar - " + error); 
        })  
    },
    gravar() {        
        if (this.formularioValido()) { 
            this.$vs.loading();

            const params = new URLSearchParams();    
            
            if (this.data_local.hasOwnProperty('id')) {
                params.append("id", this.data_local.id);
            }
            
            params.append("conta.id", this.data_local.conta.id);
            params.append("conta.numeroConta", this.data_local.conta.numeroConta);
            params.append("conta.favorecido.nome",  this.data_local.conta.favorecido.nome);
            params.append("conta.vencimento", this.data_local.conta.vencimento);
            params.append("conta.valor", this.data_local.conta.valor);
            params.append("dataInicioRecorrencia", this.data_local.dataInicioRecorrencia);
            if (this.data_local.dataFimRecorrencia) {
                params.append("dataFimRecorrencia", this.data_local.dataFimRecorrencia);
            }
            params.append("periodicidade", this.data_local.periodicidade);
            
            axios.post(URL_SERVLET + "/GravarContaRecorrente", params, {              
                    credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
            .then((response) => {                
                if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {                                        
                    this.$router.push({ path: '/' });
                } else {                    
                    if (response.data.ContaRecorrente.erroOperacao) {                 
                        this.$vs.loading.close();
                        this.$vs.dialog({ color: 'danger', title: 'Erro', text: response.data.ContaRecorrente.mensagemResultadoOperacao, acceptText: 'OK'})
                    } else {                        
                         this.$vs.notify({
                            title: "Mensagem", iconPack: 'feather', icon: 'icon-info', color: 'success',
                            text: response.data.ContaRecorrente.mensagemResultadoOperacao,
                        });

                        this.data_local = response.data.ContaRecorrente;      
                        this.findById();                    
                    }                   
                }
            })
            .catch((error) => { 
                this.$vs.loading.close();
                /* eslint-disable no-console */ console.log("EFETUAR LOGOFF! - gravar - " + error); 
            })  
        }         
    },
    voltar() {
        this.$router.push({
            name: NAME_ROUTE_SEARCH                     
        })
    },
    formularioValido() {
        this.$refs.errosComponent.iniciar();
        this.errorsValidacao = [];
      
        if (!this.data_local.conta || !this.data_local.conta.id) { this.errorsValidacao.push("Conta obrigatório"); }
        if (!this.data_local.periodicidade) { this.errorsValidacao.push("Periodicidade obrigatório"); }
        if (!this.data_local.dataInicioRecorrencia) { this.errorsValidacao.push("Data de Início da Recorrência obrigatório"); }
        
        if (!this.errorsValidacao.length) {
            return true;
        }   
        return false;
    },
    onRowSelectedRegistro(evento) {      
      let registro = evento.node.data;     
      this.data_local.conta = registro;
      this.popUpPesquisaConta.popupActive = false;
    },
  }
}
</script>

<style scoped>
  .tabelaComScroll {      
      overflow: auto;  
      height: calc(100vh - 300px);
      position: relative;      
    } 
</style>

<style lang="scss">
  
  .rag-green-outer {
    background-color: rgb(252, 222, 196) !important;
  }

  .rag-amber-outer {
    background-color: rgb(250, 74, 74) !important;
    color: white  !important;
  }

  .rag-cancelada {
     color: grey !important;
     background-color: rgb(225, 230, 161) !important;
     text-decoration: line-through !important;
  }
</style>